import React from 'react';

import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { ReportGridGroupRow } from 'src/components';
import { useCellStyles } from 'src/components';
import type { LabelSubset } from 'src/types';
import type { DocumentWithLabels } from 'src/workflow/labels';
import { DocumentLabelList } from 'src/workflow/labels';

export function DocumentLabelCell({
  row,
}: GridCellParams<DocumentWithLabels | ReportGridGroupRow, LabelSubset[]>) {
  const cellClasses = useCellStyles();

  /**
   * In tree/relationship modes the grid can render non-document rows (e.g., group nodes).
   * Those rows don't have role/owner metadata required by DocumentLabelEditor.
   */
  if (row.__typename !== 'Document') return null;

  return (
    <div className={cellClasses.cell}>
      <DocumentLabelList
        fitToWidth
        document={row}
        popoverProps={{
          anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
          style: { transform: `translateY(4px)` },
          transformOrigin: { horizontal: 'left', vertical: 'top' },
        }}
      />
    </div>
  );
}
